package routes

enum class EnumRoutes(val routeID:String) {
    Dashboard("/"),
    AdminLogin("/admin-login"),
    Properties("/properties"),
    AddProperty("/add-property"),
    EditProperty("/edit-property"),
    OwnerSubmissions("/owner-submissions"),
    PropertyInquiries("/property-inquiries"),
    PropertyListing("/property-listing"),
//    SubmitProperty("/submit-property"),
//    About("/about"),
//    Contact("/contact"),
//    FAQs("/faqs"),
//    TermsAndConditions("/terms-and-conditions"),
//    PrivacyPolicy("/privacy-policy"),
    ScheduledVisit("/scheduled-visit"),
    AdminProfile("/admin-profile")
}

enum class EnumMainNavRoutes(val routeID: String, val routeName: String){
    Properties("/properties","Properties"),
    SubmitProperty("/submit-property", "Submit Property"),
    About("/about", "About"),
    Contact("/contact", "Contact"),
}

enum class EnumPropertiesMenu(val routeID: String, val routeName: String){
    All("#all","All"),
    Rent("#forRent","For Rent"),
    Sale("#forSale","For Sale"),
}